import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    localCustomParagraph: {
      margin: '20px 0 20px',
    },
  })
);

export default useStyles;
